import { render, staticRenderFns } from "./PhaseComponent.vue?vue&type=template&id=4888f5f9&"
import script from "./PhaseComponent.vue?vue&type=script&lang=js&"
export * from "./PhaseComponent.vue?vue&type=script&lang=js&"
import style0 from "./PhaseComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports